import { Pencil, Plus, Trash2 } from 'lucide-react';
import type { MemoryItem } from '../types';

export interface MemoryPanelProps {
  memories: MemoryItem[];
  /** 点击编辑：页面打开记忆编辑器。 */
  onEdit: (memory: MemoryItem) => void;
  /** 删除记忆策略（页面内确认后调用接口）。 */
  onDelete: (memoryId: string) => void;
  /** 新增记忆策略。 */
  onAdd: () => void;
}

/** 记忆维度面板：记忆策略列表（新增 / 编辑 / 删除）。 */
export default function MemoryPanel({ memories, onEdit, onDelete, onAdd }: MemoryPanelProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 style={{ margin: 0 }}>记忆策略 ({memories.length})</h3>
        <button className="primary" style={{ padding: '6px 12px', fontSize: 13 }} onClick={onAdd}>
          <Plus size={14} /> 新增记忆
        </button>
      </div>
      {memories.length === 0 && <p className="text-muted">暂无记忆策略，点击右上角新增</p>}
      <div className="list">
        {memories.map((m) => (
          <div key={m.id} className="list-item">
            <div className="list-item-content">
              <strong>{m.memory_type}</strong>
              <div className="text-muted" style={{ fontSize: 13, marginTop: 4 }}>{m.description || '无描述'}</div>
            </div>
            <div className="list-item-actions">
              <button className="secondary" style={{ padding: '6px 10px' }} onClick={() => onEdit(m)}>
                <Pencil size={14} />
              </button>
              <button className="danger" style={{ padding: '6px 10px' }} onClick={() => onDelete(m.id)}>
                <Trash2 size={14} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
